import { useLanguage } from '../utils/LanguageContext';
import translations from '../components/ComponentsTranslations.lang.json';
import { updateUserBirthdayClientSchema } from '../shared/validations/userValidations';
import { ValidatedForm, FormInput, FormSubmit } from './common/ValidatedForm';
import { useAuth } from '../utils/AuthContext.js';
import { getInfoForUser } from './common/util.js';
import { InfoIsFromEmployerMessage } from './common/CommonComponents.js';

const BirthdayForm = ({ onFinish }) => {
  const { lang } = useLanguage(translations);
  const { user, userEmployments, api } = useAuth();
  const { birthday, infoComesFromEmployer } = getInfoForUser(user, userEmployments, (v) => v.birthday);

  return (
    <ValidatedForm
      key="userBirthday"
      schema={updateUserBirthdayClientSchema}
      initialValues={{ birthday }}
      handleSubmit={api.updateUserBirthday}
      onFinish={onFinish}
    >
      {infoComesFromEmployer && <InfoIsFromEmployerMessage />}
      <FormInput name="birthday" type="date" />
      <FormSubmit>{lang('next')}</FormSubmit>
    </ValidatedForm>
  );
};

export default BirthdayForm;
